/*
 * @Author: fengxiaojing
 * @LastEditTime: 2022-10-26 18:05:42
 * @Description:
 * @LastEditors:
 */
/* eslint-disable */
export default function(target) {
  for (let i = 1, j = arguments.length; i < j; i++) {
    const source = arguments[i] || {}
    for (const prop in source) {
      if (source.hasOwnProperty(prop)) {
        const value = source[prop]
        if (value !== undefined) {
          target[prop] = value
        }
      }
    }
  }

  return target
}
